// @ts-nocheck
import { filter, toUpper } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState, useCallback } from 'react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  Box,
  Checkbox,
  ListItemText,
  Modal,
  TextField,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { getAuthDetails } from '../store/state/authSlice';
import { useApproveCancelBookingByServiceProviderMutation } from '../store/api/bookingsApi';
import Loading from '../components/Loading';
import { SelectDatepicker } from 'react-select-datepicker';
import '../components/Style.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useGetRevenueDataByParkingMutation, useGetRevenueDataMutation } from '../store/api/revenueApi';
import { useExportToExcelMutation } from '../store/api/excelRevenueApi';
import {
  getEndDate,
  getStartDate,
  GET_REVENUE_TABDATA,
  roundNumber,
  capitalName,
  formatDateTime,
} from '../sections/@dashboard/parkingspaces/utility';
import { fDateTimeSuffix } from '../utils/formatTime';
import {
  getRevenueParking,
  getRevenueTotalRecordParking,
  getVendorRevenue,
  setRevenue,
  setRevenueParking,
} from '../store/state/revenueSlice';
import { BookingListHead } from '../sections/@dashboard/bookings';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import toast from 'react-hot-toast';
import { useFindByUserIdMutation, useSaveNotesDetailsMutation } from '../store/api/notesApi';
import { getNote, getNoteTotalRecord, setNote } from '../store/state/notesSlice';
import { useResolveDisputeMutation } from '../store/api/bookingsApi';
import ClearIcon from '@mui/icons-material/Clear';
import { Formik } from 'formik';
import * as Yup from 'yup';
import AllParkingsListHead from '../sections/@dashboard/bookings/AllParkingsListHead';

import { BorderColor } from '@material-ui/icons';

const ResponsiveBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '20px',
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));


const TABLE_HEAD_RESOLVE = [
  { id: 'BookingCode', label: 'Booking Code', alignRight: false },
  { id: 'CustomerName', label: 'Customer Name', alignRight: false },
  { id: ' BookingDate', label: ' Booking Date', alignRight: false },
  { id: 'pickupDate', label: 'Pickup Date', alignRight: false },
  { id: 'dropoffDate', label: 'Dropoff Date', alignRight: false },
  { id: 'resolveDate', label: 'Dispute Resolved Date', alignRight: false },
  { id: 'Amount', label: 'Amount', alignRight: false },
  // { id: 'Reward', label: 'Reward', alignRight: false },
  { id: 'BookingStatus', label: 'Booking Status', alignRight: false },
  { id: 'Status', label: 'Status', alignRight: false },
  { id: 'Action', label: 'Action', alignRight: false },
  // { id: 'Add', label: 'Add Notes', alignRight: false },
  // { id: 'View', label: 'View Notes', alignRight: false },
];
const TABLE_HEAD_DISPUTE = [
  { id: 'BookingCode', label: 'Booking Code', alignRight: false },
  { id: 'CustomerName', label: 'Customer Name', alignRight: false },
  { id: ' BookingDate', label: ' Booking Date', alignRight: false },
  { id: 'pickupDate', label: 'Pickup Date', alignRight: false },
  { id: 'dropoffDate', label: 'Dropoff Date', alignRight: false },
  { id: 'disputeDate', label: 'Dispute Date', alignRight: false },
  { id: 'Amount', label: 'Amount', alignRight: false },
  // { id: 'Reward', label: 'Reward', alignRight: false },
  { id: 'BookingStatus', label: 'Booking Status', alignRight: false },
  { id: 'Status', label: 'Status', alignRight: false },
  { id: 'Action', label: 'Action', alignRight: false },
  // { id: 'Add', label: 'Add Notes', alignRight: false },
  // { id: 'View', label: 'View Notes', alignRight: false },
];

const TABLE_HEAD_FOR_NOTES = [
  { id: 'Name', label: 'Name', alignRight: false },
  { id: 'Description', label: 'Description', alignRight: false },
  { id: 'Add', label: 'Creation Date', alignRight: false },
];

let flag = ['Active_Transaction', 'Disputed_Transaction'];

const NotesSchema = Yup.object().shape({
  description: Yup.string().required().typeError('Please enter description'),
});

export default function ParkingWiseData() {
  const dispatch = useAppDispatch();
  const location: any = useLocation();
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('login')) || null;
  const userType = JSON.parse(localStorage.getItem('login')).userType || null;
  const User = JSON.parse(localStorage.getItem('login')) || null;

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selecteds, setSelecteds] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [revenues, setRevenues] = useState([]);
  const [value, setValue] = useState<Date | null>(new Date());
  const [getRevenueDataByParking, getAllResponse] = useGetRevenueDataByParkingMutation();
  const BookingData = useAppSelector(getRevenueParking);
  const [cancellations, setAllCancellations] = useState();
  const bookingTotalRecords = useAppSelector(getRevenueTotalRecordParking);
  const [getRevenueData, revenueResponse] = useGetRevenueDataMutation();
  const [exportToExcel, exportToExcelResponse] = useExportToExcelMutation();
  const revenueData = useAppSelector(getVendorRevenue);
  const [resolveDispute, resolveDisputeResponse] = useResolveDisputeMutation();
  const [editOpen, setEditOpen] = useState(false);
  const handleOpens = () => setEditOpen(true);
  const handleCloses = () => setEditOpen(false);
  const [bookingId, setBookingId] = useState({});
  const [showOpen, setShowOpen] = useState(false);
  const handleShowOpen = () => setShowOpen(true);
  const handleShowClose = () => setShowOpen(false);
  const [bookingIdS, setBookingIdS] = useState();
  const [pages, setPages] = useState(0);
  const [noteData, noteDataResponse] = useFindByUserIdMutation();
  const filteredNotes = noteDataResponse?.data?.data ? noteDataResponse?.data?.data : [];
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const [bookingSpaces, setParkingData] = useState({});
  const role = useAppSelector(getAuthDetails);
  const [initialValues, setInitialValues] = useState({
    description: '',
  });
  const [saveNotesDetail, saveNotesDetailResponse] = useSaveNotesDetailsMutation();
  const [orders, setOrders] = useState('desc');
  const [ordersBy, setOrdersBy] = useState('id');
  const [selected, setSelected] = useState([]);
  const [notesData, setNotesData] = useState([]);
  const getnotesData = useAppSelector(getNote);
  const notesTotalRecord = useAppSelector(getNoteTotalRecord);
  const [rowsPerPages, setRowsPerPages] = useState(50);
  const [valueTabs, setValueTabs] = useState(0);
  const [getFlag, setFlag] = useState(flag[0]);
  const filteredUsers = cancellations?.data ? cancellations?.data : [];
  const [variantName, setVariantName] = useState(getAllParking());
  const onDateChange = useCallback((date: Date) => {
    setValue(date);
  }, []);
  let revenueList: any = revenues[0]?.parkingSpaceRevenueDataList;

  useEffect(() => {
    getRevenueDataByParking({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        serviceProviderId: token.serviceProviderId,
        parkingIdLists: [location.state.id],
        isDisputed: false,
      },
    });
  }, [getRevenueDataByParking]);

  const getRevenueDataAsync = async (newpage, parkingPerPage) => {
    await getRevenueDataByParking({
      token: token.token,
      payload: {
        page: newpage,
        offset: parkingPerPage,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        serviceProviderId: token.serviceProviderId,
        parkingIdLists: [location.state.id],
        isDisputed: getFlag == 'Disputed_Transaction' ? true : false,
      },
    });
  };

  useEffect(() => {
    if (getAllResponse.isSuccess) {
      dispatch(setRevenueParking(getAllResponse.data));
    }
  }, [getAllResponse.isSuccess]);

  useEffect(() => {
    if (BookingData) {
      setAllCancellations(BookingData);
    }
  }, [BookingData]);

  useEffect(() => {
    getRevenueData({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        serviceProviderId: token.serviceProviderId,
        isDisputed: false,
      },
    });
  }, [getRevenueData]);

  useEffect(() => {
    if (revenueResponse.isSuccess) {
      dispatch(setRevenue(revenueResponse.data.revenueData));
    }
  }, [revenueResponse.isSuccess]);

  useEffect(() => {
    if (revenueData) {
      setRevenues(revenueData);
    }
  }, [revenueData]);

  const handleChangePage = async (event, newPage: any) => {
    setPage(newPage);
    await getRevenueDataAsync(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getRevenueDataAsync(0, parseInt(event.target.value, 10));
  };

  function getAllParking() {
    let parkingId: any = [];
    let item = location.state.data;
    parkingId.push(item);
    return parkingId;
  }

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    let duplicateRemoved = [];
    value.forEach((item) => {
      if (duplicateRemoved.findIndex((o) => o.id === item.id) >= 0) {
        duplicateRemoved = duplicateRemoved.filter((x) => x.id === item.id);
      } else {
        duplicateRemoved.push(item);
      }
    });
    setVariantName(duplicateRemoved);
  };

  function handleSubmits() {
    let parkingIdLists: any = [];
    variantName.forEach((item: any, index: number) => {
      parkingIdLists.push(item.id);
    });
    getRevenueDataByParking({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        serviceProviderId: token.serviceProviderId,
        parkingIdLists: parkingIdLists,
        isDisputed: getFlag == 'Disputed_Transaction' ? true : false,
      },
    });
  }

  const handleSubmitExcel = (fileName: any) => {
    let parkingIdLists: any = [];
    variantName.forEach((item: any, index: number) => {
      parkingIdLists.push(item.id);
    });
    exportToExcel({
      token: token.token,
      fileName: userType,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        serviceProviderId: token.serviceProviderId,
        parkingIdLists: parkingIdLists,
        isDisputed: getFlag == 'Disputed_Transaction' ? true : false,
      },
    });
  };


  useEffect(() => {
    if (exportToExcelResponse.isSuccess) {
      console.log("exportToExcelResponse ", exportToExcelResponse);
      const url = window.URL.createObjectURL(new Blob([exportToExcelResponse.data]));
      const link: any = document.createElement("a");
      link.href = url;
      link.setAttribute(
        'download',
        `${formatDateTime(exportToExcelResponse?.originalArgs.toDate, 'MM/DD/yyyy') + '-RevenueData'}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  }, [exportToExcelResponse.isSuccess]);

  const handleChangeTabs = (event, newValue) => {
    setValueTabs(newValue);
    setFlag(flag[newValue]);
    getRevenueDataByParking({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
        toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
        parkingIdLists: [location.state.id],
        serviceProviderId: token.serviceProviderId,
        isDisputed: flag[newValue] == 'Disputed_Transaction' ? true : false,
      },
    });
  };

  function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
          event.preventDefault();
        }}
        {...props}
      />
    );
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = cancellations.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleSelectAllClicks = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelecteds(newSelecteds);
      return;
    }
    setSelecteds([]);
  };

  const handleResolveClick = (id: any) => {
    resolveDispute({
      token: token.token,
      payload: {
        bookingIds: [id],
        disputeResolutionDate: new Date(),
        isDisputed: false,
      },
    });
  };

  useEffect(() => {
    if (resolveDisputeResponse.isSuccess) {
      getRevenueDataByParking({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          fromDate: getStartDate(GET_REVENUE_TABDATA[2], value),
          toDate: getEndDate(GET_REVENUE_TABDATA[2], value),
          parkingIdLists: [location.state.id],
          serviceProviderId: token.serviceProviderId,
          isDisputed: getFlag == 'Disputed_Transaction' ? true : false,
        },
      });
      if (getFlag == 'Disputed_Transaction') {
        toast.success('Transaction resolved successfully.');
      } else {
        toast.success('Transaction marked as dispute.');
      }
    } else if (resolveDisputeResponse.isError) {
      let errorData: any = resolveDisputeResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [resolveDisputeResponse.isSuccess, resolveDisputeResponse.isError]);

  const handleDisputeClick = (id: any) => {
    resolveDispute({
      token: token.token,
      payload: {
        bookingIds: [id],
        disputeResolutionDate: new Date(),
        isDisputed: true,
      },
    });
  };

  const getAddedNotes = (values: any) => {
    setBookingIdS(value);
    noteData({
      token: token.token,
      payload: {
        offset: rowsPerPages,
        page: pages,
        bookingId: values,
      },
    });
  };

  const handleChangeNote = (event, newPages: any) => {
    setPages(newPages);
    noteData({
      token: token.token,
      payload: {
        offset: rowsPerPages,
        page: newPages,
        bookingId: bookingIds,
      },
    });
  };
  const handleRequestSort = (event, property) => {
    const isAsc = ordersBy === property && orders === 'asc';
    setOrders(isAsc ? 'desc' : 'asc');
    setOrdersBy(property);
  };

  useEffect(() => {
    if (noteDataResponse.isSuccess) {
      dispatch(setNote(noteDataResponse.data));
    }
    if (noteDataResponse.isError) {
      let errorData: any = noteDataResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [noteDataResponse.isSuccess, noteDataResponse.isError]);

  const handleAddNotes = (values: any, action: any) => {
    saveNotesDetail({
      token: token.token,
      payload: {
        description: values.description,
        userId: User.userId,
        bookingId: bookingId,
      },
    });
  };
  useEffect(() => {
    if (saveNotesDetailResponse.isSuccess) {
      toast.success('Successfully added note');
    }
    if (saveNotesDetailResponse.isError) {
      let errorData: any = saveNotesDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong. Please try again.' + msg || '');
    }
  }, [saveNotesDetailResponse.isSuccess, saveNotesDetailResponse.isError]);

  useEffect(() => {
    if (getnotesData) {
      setNotesData(getnotesData);
    }
  }, [getnotesData]);

  const handleChangeRowsPerPages = (event) => {
    setRowsPerPages(parseInt(event.target.value, 10));
    setPages(0);
    noteData({
      token: token,
      payload: {
        offset: event.target.value,
        page: 0,
        bookingId: bookingIdS,
      },
    });
  };

  const styleActiveModel = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '40px',
    px: '40px',
  };
  const styleActiveModelEdit = {
    position: 'absolute' as 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '40px',
    px: '40px',
  };
  const styleActiveModelAdd = {
    position: 'absolute' as 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '40px',
    px: '40px',
  };

  return (
    <Page title="Revenue">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Vendor Revenue
          </Typography>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              navigate('/dashboard/revenue', { replace: true });
            }}
            sx={{ marginBottom: '10px' }}
            size="medium"
          >
            <ArrowBackIcon />
          </Button>
        </Stack>

        <Card>
          <ResponsiveBox style={{ display: 'flex' }}>
            <Box>
              <SelectDatepicker selectedDate={value} onDateChange={onDateChange} order="month/year" hideLabels="true" />
            </Box>

            <Button
              className="ButtonWith"
              style={{
                width: '50px',
                borderColor: '#E23744',
                backgroundColor: '#E23744',
                padding: '10px',
                marginLeft: '10px',
                alignItems: 'center',
                height: '52px',
                marginTop: '40px',
              }}
              onClick={() => {
                handleSubmits();
              }}
              variant="contained"
            >
              Submit
            </Button>
            <Button
              className="ButtonWith"
              style={{
                width: '50px',
                borderColor: '#E23744',
                backgroundColor: '#E23744',
                padding: '10px',
                marginLeft: '10px',
                alignItems: 'center',
                height: '52px',
                marginTop: '40px',
              }}
              onClick={() => {
                handleSubmitExcel(filteredUsers[0].vendorAlias);
              }}
              variant="contained"
            >
              Excel Export
            </Button>
          </ResponsiveBox>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            mb={5}
            mt={5}
            style={{ width: '100%' }}
          >
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="nav tabs example"
              style={{ width: '100%' }}
              className="tabResponsive"
            >
              <LinkTab label="Active Transaction" style={{ width: '100%' }} />
              <LinkTab
                label="Disputed Transaction"
                style={{ width: '100%', marginLeft: '300px' }}
                className="linkResponsive"
              />
            </Tabs>
          </Stack>

          <Stack mb={3} style={{ marginLeft: '10px', marginTop: '20px' }}>
            <Typography variant="h4" gutterBottom>
              Summary of Listing Activity
            </Typography>
          </Stack>

          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <tr>
              <th
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Transactions
              </th>
              <th
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Amount
              </th>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Number of Transactions
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                {cancellations?.totalRecords}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Total Number of Cancelled Bookings
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                {cancellations?.totalCancelledBooking}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Total Gross Amount
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalGrossAmount)}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Cancelled Transactions Amount
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalCancellationAmount)}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Tax Collected
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalTaxAmount)}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Total Amount Before Tax
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalBookingAmount)}
              </td>
            </tr>

            <tr>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                Total Amount After Tax Collected
              </td>
              <td
                style={{
                  textAlign: 'left',
                  padding: '20px',
                  marginLeft: '20px',
                  borderBottom: '1px solid rgba(241, 243, 244, 1)',
                }}
              >
                ₹{roundNumber(cancellations?.totalVendorCommission)}
              </td>
            </tr>
          </table>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table style={{ marginTop: '55px' }}>
                <BookingListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={getFlag == "Disputed_Transaction" ? TABLE_HEAD_DISPUTE : TABLE_HEAD_RESOLVE}
                  rowCount={cancellations?.length}
                  numSelected={selected.length}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const {
                        id,
                        name,
                        parkingSpaceLocationName,
                        bookingCode,
                        customerName,
                        bookingDate,
                        checkInDate,
                        checkOutDate,
                        totalAmount,
                        rewardUsedAmount,
                        taxAmount,
                        actualCheckInDate,
                        actualCheckOutDate,
                        bookingStatus,
                        bookingId,
                        isVendorPaid,
                        disputeResolutionDate,
                      } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell
                            align="left"
                            style={{
                              color: 'blue',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              setParkingData(row);
                              handleOpen();
                            }}
                          >
                            {bookingCode}
                          </TableCell>
                          <TableCell align="left">{customerName}</TableCell>
                          <TableCell align="left">{fDateTimeSuffix(bookingDate)}</TableCell>
                          <TableCell align="left">{fDateTimeSuffix(checkInDate)}</TableCell>
                          <TableCell align="left"> {fDateTimeSuffix(checkOutDate)}</TableCell>
                          <TableCell align="left">{disputeResolutionDate ? (fDateTimeSuffix(disputeResolutionDate)) : "N/A"}</TableCell>
                          <TableCell align="left">₹{roundNumber(totalAmount)}</TableCell>
                          {/* <TableCell align="left">{roundNumber(rewardUsedAmount)}</TableCell> */}
                          {/* <TableCell align="left">${roundNumber(taxAmount)}</TableCell> */}
                          <TableCell align="left" style={{ fontWeight: 'bold' }}>
                            {toUpper(
                              actualCheckInDate != null && actualCheckOutDate == null && bookingStatus == 'booked'
                                ? 'CHECKIN'
                                : capitalName(bookingStatus)
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {isVendorPaid === true ? (
                              <p style={{ color: 'green', fontWeight: 'bold' }}>PAID</p>
                            ) : (
                              <p style={{ color: 'red', fontWeight: 'bold' }}>UNPAID</p>
                            )}
                          </TableCell>

                          {getFlag == 'Disputed_Transaction' ? (
                            <TableCell align="left">
                              <Button variant="contained"
                                style={{ color: 'white', backgroundColor: '#E23744' }}
                                onClick={() => handleResolveClick(id)}>
                                Resolve
                              </Button>
                            </TableCell>
                          ) : (
                            <TableCell align="left">
                              <Button style={{ color: 'white', backgroundColor: '#E23744' }}
                                variant="contained"
                                onClick={() => handleDisputeClick(id)}>
                                Dispute
                              </Button>
                            </TableCell>
                          )}
                          {/* <TableCell align="left">
                            <EditIcon
                              onClick={() => {
                                handleOpens();
                                setBookingId(id);
                              }}
                              style={{ cursor: 'pointer' }}
                            />
                          </TableCell>
                          <TableCell align="left">
                            <RemoveRedEyeIcon
                              onClick={() => {
                                handleShowOpen();
                                getAddedNotes(id);
                              }}
                              style={{ cursor: 'pointer' }}
                            />
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
              {filteredUsers.length == 0 ? (
                <Typography gutterBottom align="center" variant="subtitle1" style={{ marginTop: 25, marginBottom: 25 }}>
                  No record found!!!{' '}
                </Typography>
              ) : (
                ''
              )}
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[50, 100, 150]}
            component="div"
            count={bookingTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ alignItems: 'center', marginTop: '10%', innerWidth: '40%', overflow: 'scroll' }}
      >
        <Box sx={styleActiveModel} style={{ overflowY: 'auto', height: '85%' }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Booking Details
            </Typography>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                handleClose();
              }}
              size="medium"
            >
              <ClearIcon />
            </Button>
          </Stack>
          <Box border={1} borderRadius={2} borderColor={'white'} style={{ backgroundColor: 'white' }}>
            <Box marginLeft={1} padding={3}>
              <Box>
                <Box>
                  <Box display="flex" gap={1} alignItems="center">
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Customer Name :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {bookingSpaces?.customerName && bookingSpaces?.customerName
                        ? capitalName(bookingSpaces?.customerName)
                        : null}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Vehicle Name :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {bookingSpaces?.vehicleDetailObj?.model && bookingSpaces?.vehicleDetailObj?.model
                        ? capitalName(bookingSpaces?.vehicleDetailObj?.model)
                        : null}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Booking Code :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {bookingSpaces?.bookingCode}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Transaction Id :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {bookingSpaces?.transactionRefId}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} width={150} gutterBottom>
                      Pickup Date :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {formatDateTime(bookingSpaces?.checkInDate, 'MM/DD/yyyy, hh:mm A')}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} width={150} gutterBottom>
                      Dropoff Date :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {formatDateTime(bookingSpaces?.checkOutDate, 'MM/DD/yyyy, hh:mm A')}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} width={150} gutterBottom>
                      Booking Date :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {formatDateTime(bookingSpaces?.bookingDate, 'MM/DD/yyyy, hh:mm A')}
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Booking Status :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      {bookingSpaces.actualCheckInDate !== null &&
                        bookingSpaces.actualCheckOutDate == null &&
                        bookingSpaces.bookingStatus == 'booked'
                        ? 'Checkin'
                        : bookingSpaces.bookingStatus}
                    </Typography>
                  </Box>
                  {bookingSpaces.cancellationReasonName == null ? (
                    ''
                  ) : (
                    <Box display="flex" gap={2}>
                      <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                        Cancellation Reason:
                      </Typography>
                      <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                        {bookingSpaces.cancellationReasonName}
                      </Typography>
                    </Box>
                  )}

                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Booking Amount :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      ₹{bookingSpaces?.bookingAmount}
                    </Typography>
                  </Box>

                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Total Tax &nbsp;&nbsp;&nbsp;&nbsp;:
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      ₹{bookingSpaces?.taxAmount}
                    </Typography>
                  </Box>
                  {/* {checkPermissions(PERMISSION.USER_MGMT_ADD, token.permissions)? */}
                  {role && role.roleIdName == 'Super Admin' ? (
                    <Box display="flex" gap={2}>
                      <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                        Convenience Fee :
                      </Typography>
                      <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                        ₹{bookingSpaces.convenienceFee}
                      </Typography>
                    </Box>
                  ) : null}
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Used Reward :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      ₹{bookingSpaces?.rewardUsed == null || 0 ? 0 : bookingSpaces?.rewardUsed}
                    </Typography>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom>
                      Total Booking Amount :
                    </Typography>
                    <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom>
                      ₹{bookingSpaces.totalAmount}
                    </Typography>
                  </Box>
                  {/**bookingSpaces.countyTax == null ? (
                    ''
                  ) : (
                    <Box display="flex" gap={2}>
                      <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        County Tax Amount :
                      </Typography>
                      <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        ₹{bookingSpaces.countyTax}
                      </Typography>
                    </Box>
                  ) */}
                  {bookingSpaces.salesTax == null ? (
                    ''
                  ) : (
                    <Box display="flex" gap={2}>
                      <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        CGST Amount :
                      </Typography>
                      <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        ₹{bookingSpaces.salesTax}
                      </Typography>
                    </Box>
                  )}
                  {bookingSpaces.stateTax == null ? (
                    ''
                  ) : (
                    <Box display="flex" gap={2}>
                      <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        SGST Amount :
                      </Typography>
                      <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        ₹{bookingSpaces.stateTax}
                      </Typography>
                    </Box>
                  )}
                  {bookingSpaces.fixedFee == null ? (
                    ''
                  ) : (
                    <Box display="flex" gap={2}>
                      <Typography variant="h6" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        Fixed Fee:
                      </Typography>
                      <Typography variant="p" fontSize={18} marginBottom={0} gutterBottom className="fontstyle">
                        ₹{bookingSpaces.fixedFee}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={editOpen}
        onClose={handleCloses}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ alignItems: 'center', marginTop: '10%', innerWidth: '40%' }}
      >
        <Box sx={styleActiveModelEdit} style={{ overflowY: 'auto', height: '70%', width: '50%' }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Add Notes
            </Typography>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                handleCloses();
              }}
              size="medium"
            >
              <ClearIcon />
            </Button>
          </Stack>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={handleAddNotes}
            validationSchema={NotesSchema}
          >
            {({ handleBlur, handleChange, handleSubmit, setFieldValue, values, touched, errors, resetForm }) => (
              <Box>
                <Box style={{ width: '100%' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Description
                  </Typography>
                  <TextField
                    type="description"
                    id="description"
                    name="description"
                    label="description"
                    multiline
                    rows={6}
                    style={{ width: '100%' }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.description && errors.description)}
                    helperText={touched.description && errors.description}
                  />
                </Box>
                <Stack direction="row" justifyContent={'end'} marginTop={'20px'} alignItems={'center'}>
                  <Button
                    onClick={() => {
                      handleSubmit();
                      handleCloses();
                    }}
                    variant="contained"
                    sx={{ padding: '8px', width: '100px' }}
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                  >
                    ADD
                  </Button>
                </Stack>
              </Box>
            )}
          </Formik>
        </Box>
      </Modal>

      <Modal
        open={showOpen}
        onClose={handleShowClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ alignItems: 'center', marginTop: '10%', innerWidth: '40%', innerHeight: '50' }}
      >
        <Box
          sx={styleActiveModelAdd}
          style={{
            overflowY: 'auto',
            width: '60%',
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Notes Details
            </Typography>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                handleShowClose();
                setPages(0);
              }}
              size="medium"
            >
              <ClearIcon />
            </Button>
          </Stack>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={orders}
                  orderBy={ordersBy}
                  headLabel={TABLE_HEAD_FOR_NOTES}
                  rowCount={notesData.length}
                  numSelected={selecteds.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClicks}
                />
                <TableBody>
                  {filteredNotes.length > 0 &&
                    filteredNotes.map((row) => {
                      const { id, createdByName, createdDate, description } = row;
                      const isItemSelected = selecteds.indexOf(createdByName) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id.toString()}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {createdByName}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {description}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {formatDateTime(createdDate, 'MM/DD/yyyy, hh:mm A')}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

                {filteredNotes.length === 0 && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[50, 100, 150]}
            component="div"
            count={notesTotalRecord || 0}
            rowsPerPage={rowsPerPages}
            page={pages}
            onPageChange={handleChangeNote}
            onRowsPerPageChange={handleChangeRowsPerPages}
          />
        </Box>
      </Modal>

      {getAllResponse.isLoading ||
        revenueResponse.isloadingn ||
        noteDataResponse.isLoading ||
        resolveDisputeResponse.isLoading ? (
        <Loading />
      ) : null}
    </Page>
  );
}
